import {computed, type MaybeRef, unref} from 'vue';
import {helpers, useRoute} from '@typed-router';

type RouteParams = {
    projectId?: string;
    quoteId?: string;
};

export function useProjectClientRedirect(from?: MaybeRef<string | undefined>) {
    const route = useRoute();

    const originUrl = computed(() => {
        const fromQuery = unref(from);
        const params = route.params as RouteParams;
        if (params.projectId && route.query.origin === 'project-view') {
            return helpers.route({path: `/project/${params.projectId}`, ...(fromQuery && {query: {origin: fromQuery}})});
        } else {
            return helpers.route({path: '/', ...(fromQuery && {query: {origin: fromQuery}})});
        }
    });

    return {
        originUrl,
    };
}
